(ns ui.view.card.property-list.model)

(def saving-changes-path [:saving-changes?])

(defn saving-changes-full-path
  [card-state-path]
  (into card-state-path saving-changes-path))

(def edit-mode-path [:edit-mode?])

(defn edit-mode-full-path
  [card-state-path]
  (into card-state-path edit-mode-path))

(def entity-edits-path [:entity-edits])

(defn entity-edits-full-path
  [card-state-path]
  (into card-state-path entity-edits-path))

(def entity-edit-entities-path [:entity-edit-entities])

(defn entity-edit-entities-full-path
  [card-state-path]
  (into card-state-path entity-edit-entities-path))

(def show-all-fields-in-editor-path [:show-all-fields-in-editor?])

(defn show-all-fields-in-editor-full-path
  [card-state-path]
  (into card-state-path show-all-fields-in-editor-path))

(defn entity-edits-field-value-full-path
  [card-state-path entity-id field]
  (into (entity-edits-full-path card-state-path) [entity-id field]))

(def submit-errors-path [:submit-errors])

(defn submit-errors-full-path
  [card-state-path]
  (into card-state-path submit-errors-path))
